import { z } from 'zod';

// コメント基本情報の型定義
export const CommentSchema = z.object({
  id: z.number(),
  video_id: z.union([z.number(), z.string()]),
  user_id: z.union([z.number(), z.string()]),
  content: z.string(),
  created_at: z.string(),
  updated_at: z.string().optional(),
  deleted_at: z.string().nullable().optional(),
  // ユーザー情報などの関連データが含まれる可能性があるため拡張可能な形に
  user: z.object({
    id: z.union([z.number(), z.string()]),
    name: z.string(),
    icon_path: z.string().nullable().optional(),
    avatar_url: z.string().nullable().optional()
  }).optional(),
  childCount: z.number().optional(),
  likeCount: z.number().optional()
});

export type Comment = z.infer<typeof CommentSchema>;

/**
 * コメント一覧取得リクエスト
 * 注意: 現在の実装ではオブジェクトではなく個別パラメータとして渡します
 * @deprecated このインターフェースは将来的な使用のために保持されています
 */
export interface FetchCommentsReq {
  video_id: number | string;
  page?: number;
  limit?: number;
}

// コメント一覧レスポンス
export const FetchCommentsResSchema = z.object({
  comments: z.array(CommentSchema),
  pagination: z.object({
    totalItems: z.number(),
    currentPage: z.number(),
    totalPages: z.number(),
    pageSize: z.number()
  })
});

export type FetchCommentsRes = z.infer<typeof FetchCommentsResSchema>;

// コメント作成リクエスト
export interface CreateCommentReq {
  video_id: number | string;
  content: string;
}

// コメント作成レスポンス
export const CreateCommentResSchema = z.object({
  message: z.string(),
  comment: CommentSchema
});
export type CreateCommentRes = z.infer<typeof CreateCommentResSchema>;

// コメント更新リクエスト
export interface UpdateCommentReq {
  content: string;
}

// コメント更新レスポンス
export const UpdateCommentResSchema = CommentSchema;
export type UpdateCommentRes = z.infer<typeof UpdateCommentResSchema>;

// コメント削除レスポンス
export const DeleteCommentResSchema = z.object({
  message: z.string(),
  id: z.number()
});

export type DeleteCommentRes = z.infer<typeof DeleteCommentResSchema>; 
